import { set } from "lodash";

const testKey = 'data-testid';
const testIdClassName = 'testid';

// id for testing
export const tid = (identifier) => {
  return {
    [testKey]: identifier
  }
}

let testIdToggleState = false;
export const toggleTestId = () => {
  if(testIdToggleState) {
    document.body.classList.remove(testIdClassName);
  } else {
    document.body.classList.add(testIdClassName);
  }
  testIdToggleState = !testIdToggleState;
}

// for dev/QE debugging
set(window,['testTools','toggleTestId'], toggleTestId);

